import { render, staticRenderFns } from "./index.vue?vue&type=template&id=574e23d8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e23d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574e23d8')) {
      api.createRecord('574e23d8', component.options)
    } else {
      api.reload('574e23d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=574e23d8&scoped=true&", function () {
      api.rerender('574e23d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Contact/index.vue"
export default component.exports